export default "__VITE_ASSET__zQgG$oQc__"